import _Button from "@material-ui/core/esm/Button";
import _InputBase from "@material-ui/core/esm/InputBase";
import _ExpandMore from "@material-ui/icons/esm/ExpandMore";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useState, useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { MAX_ATTACHMENTS_COUNT_PER_ITEM_FOR_CUSTOMER, MAX_ITEM_ATTACHMENT_FILE_SIZE } from 'swag-client-common/utils/constants';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { PRIMARY_BUTTON } from '../../../../../../../../constants/styles';
import classes from '../../tools-panel.scss';
import AttachmentItem from './design-attachment-item';
import AttachmentUpload from './design-attachment-upload';
import appearAnimationClasses from './appear.anim.scss';
import toolbarItemAnimationClasses from './toolbar-item.anim.scss';
import STYLES from './design-note-styles';
const placeholder = "If you are looking to add text please add the text here. After you place your order we will create a virtual mock up that you'll approve before we go into production. We will make it look exactly like you want.";
const useStyles = makeStyles(() => ({
  saveButton: _objectSpread({}, PRIMARY_BUTTON, STYLES.saveButton),
  input: {
    padding: 0
  }
}));
export function DesignNoteComponent({
  isOpened,
  onChangeOpenedState,
  isDisabled,
  isLimitedEdition,
  notes,
  attachments,
  onSubmit,
  onDeleteAttachment
}) {
  const inputEl = useRef(null);
  const [state, changeState] = useState({
    note: notes,
    stateAttachments: attachments,
    error: ''
  });
  const {
    note,
    stateAttachments,
    error
  } = state;
  const setState = changes => changeState(_objectSpread({}, state, changes));
  const myStyles = useStyles();
  useEffect(() => {
    if (isOpened && inputEl) {
      setTimeout(() => {
        var _inputEl$current;
        return (_inputEl$current = inputEl.current) === null || _inputEl$current === void 0 ? void 0 : _inputEl$current.focus();
      }, 200);
    }
  }, [isOpened]);
  const onFileAdd = file => {
    if (file.size > MAX_ITEM_ATTACHMENT_FILE_SIZE) {
      return setState({
        error: 'The file is too large'
      });
    }
    setState({
      error: '',
      stateAttachments: [...stateAttachments, file]
    });
  };
  const onFileDelete = (index, key) => {
    if (key) {
      onDeleteAttachment(key);
    }
    const newStateAttachments = stateAttachments.filter((_, attachmentIndex) => attachmentIndex !== index);
    setState({
      stateAttachments: newStateAttachments
    });
  };
  const onNoteChange = e => {
    setState({
      note: e.target.value
    });
  };
  const onToolbarClick = () => {
    if (isDisabled) {
      return null;
    }
    onChangeOpenedState();
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: toolbarItemAnimationClasses,
    in: isOpened,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemMainColumn, {
      [classes.toolbarItemDisabled]: isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onToolbarClick,
    className: classes.toolbarItemHead,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onToolbarClick),
    "aria-label": "Design Note"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemIcon, classes.addDesignNoteToolbarIcon)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemHeadText,
    "data-button": "DesignNote"
  }, "Design Note"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemExpand, {
      [classes.toolbarItemExpandReverse]: isOpened
    })
  }, /*#__PURE__*/React.createElement(_ExpandMore, null))), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemBody, classes.toolbarItemBodyFullBorder),
    "data-block": "DesignNote"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textArea
  }, /*#__PURE__*/React.createElement(_InputBase, {
    placeholder: placeholder,
    className: myStyles.input,
    inputProps: {
      ref: inputEl
    },
    value: note,
    multiline: true
    // need for tab navigation
    ,
    disabled: !isOpened,
    onChange: onNoteChange,
    "data-input": "DesignNote"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.uploadAttachmentsSection
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, stateAttachments.map(({
    originalFileName,
    name,
    src,
    key,
    id
  }, index) => /*#__PURE__*/React.createElement(CSSTransition, {
    key: id || src,
    timeout: 250,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(AttachmentItem, {
    onFileDelete: () => onFileDelete(index, key),
    name: src ? originalFileName : name,
    src: src
  })))), /*#__PURE__*/React.createElement(CSSTransition, {
    in: stateAttachments.length < MAX_ATTACHMENTS_COUNT_PER_ITEM_FOR_CUSTOMER,
    timeout: 250,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(AttachmentUpload, {
    className: classnames({
      [classes.uploadInitial]: !stateAttachments.length,
      [classes.orangeUpload]: isLimitedEdition
    }),
    key: "upload",
    onFileAdd: onFileAdd,
    tabIndex: isOpened ? 0 : -1
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    in: !!error,
    timeout: 250,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.errorMessage
  }, error)), /*#__PURE__*/React.createElement(_Button, {
    onClick: () => {
      onSubmit({
        notes: note,
        attachments: stateAttachments
      });
      onChangeOpenedState();
    },
    disabled: isDisabled,
    color: "primary",
    variant: "contained",
    className: classnames(myStyles.saveButton, {
      [classes.orangeButton]: isLimitedEdition
    }),
    "data-button": "Confirm",
    tabIndex: isOpened ? 0 : -1
  }, "Confirm"))))));
}